module.exports = __webpack_public_path__ + "static/media/video.f54160c9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Media/video.mp4
// module id = 1141
// module chunks = 0